import { Fragment, memo } from 'react';

export type FormattedTextProps = {
  text?: string;
};

export const FormattedTextBase = ({ text = '' }: FormattedTextProps) => (
  <Fragment>
    {text
      .split('\n')
      .filter(Boolean) // Remove duplicate \n.
      .map((line, index, array) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: Text should be static anyway.
        <Fragment key={index}>
          {line}
          {index < array.length - 1 && <br />}
        </Fragment>
      ))}
  </Fragment>
);

FormattedTextBase.displayName = 'FormattedText';

export const FormattedText = memo(FormattedTextBase);
